import { Routes, Route, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from './i18n';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
import VideoDetail from './pages/VideoDetail';
import CookiePolicy from './pages/CookiePolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';

export default function App() {
  const { language } = useLanguage();

  return (
    <>
      {/* Default <title> / <html lang> for every route — pages override per-route. */}
      <Helmet>
        <html lang={language} />
      </Helmet>

      <Header />

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/video/:videoSlug" element={<VideoDetail />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="*"
            element={
              <div className="not-found">
                <p>404 — <Link to="/">home</Link></p>
              </div>
            }
          />
        </Routes>
      </main>

      <Footer />
      <CookieBanner />
    </>
  );
}
